<template>
  <div class="Home-Container">
    <vv-box :title="$t('userAccount.formationsTitle')">
      <vv-box-item
        :title="$t('home.formations')"
        @click="$router.push({ name: 'themeList' })"
        :showArrow="false"
      >
        <img src="@/assets/icons/Masterclass.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item
        :title="$t('home.tasting')"
        @click="$router.push('/listTasting')"
        :showArrow="false"
      >
        <img src="@/assets/icons/Tastings.png" width="25" height="22" />
      </vv-box-item>

      <vv-box-item
        :title="$t('home.favoriteWines')"
        @click="$router.push({ name: 'userAccountFavoriteWine' })"
        :showArrow="false"
      >
        <img src="@/assets/icons/Tasted.png" width="25" height="22" />
      </vv-box-item>


      <vv-box-item
        v-if="remoteConfig.getBoolean('gamification_enabled')"
        :title="$t('home.progression')"
        @click="$router.push('/userAccount/progression')"
        :showArrow="false"
      >
        <img src="@/assets/icons/Progress.png" width="25" height="22" />
      </vv-box-item>

      <a target="_blank" class="external-link" href='https://vinovibes.fr/pages/blog'>
        <vv-box-item
          :title="$t('menu.blog')"
          :showArrow="false"
        >
          <img src="@/assets/icons/Blog.png" width="25" height="22" />
        </vv-box-item>
      </a>
    </vv-box>

    <vv-box :title="$t('menu.shop')">
      <vv-box-item
        :title="$t('menu.wines')"
        @click="$router.push({ name: 'shop-list-bottles'})"
        :showArrow="false"
      >
        <img src="@/assets/icons/Tasted.png" width="25" height="22" />
      </vv-box-item>
      <vv-box-item
        :title="$t('menu.cart')"
        @click="$router.push({ name: 'cart' })"
        :showArrow="false"
      >
        <img src="@/assets/icons/panier.png" width="25" height="22" />
      </vv-box-item>
    </vv-box>
    <vv-box :title="$t('userAccount.myAccount')">
      <vv-box-item
        :title="$t('home.personalInformation')"
        @click="$router.push({ name: 'userAccountPersonnalInformation' })"
        :showArrow="false"
      >
        <img src="@/assets/icons/Account.png" width="25" height="22" />
      </vv-box-item>
      <vv-box-item
        v-if="isUserLogged"
        @click="logout"
        :title="$t('global.logout')"
        :show-arrow="false"
      >
        <img src="@/assets/icons/Logout.png" width="25" height="22" />
      </vv-box-item>
    </vv-box>
    <div class="list-social-media">
      <div class="item-social-media" v-for="media in socialMedia" :key="media.id">
        <a :href="media.link" target="_blank"><img :src="require(`@/assets/media_logo/${media.label}_logo.png`)"></a>
      </div>
    </div>
  </div>
</template>

<script>
import VvBox from '@/components/common/VvBox'
import VvBoxItem from '@/components/common/VvBoxItem'

import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import remoteConfig from '@/lib/remote-config'

export default {
  name: 'Home',
  mixins: [userMixin, remoteConfigMixin],
  components: {
    VvBox,
    VvBoxItem
  },
  computed: {
    socialMedia() {
      if (remoteConfig.getValue('social_media')) {
        return JSON.parse(JSON.parse(JSON.stringify(remoteConfig.getValue('social_media'))))
      }
      return []
    }
  }
}
</script>

<style scoped lang="scss">
.Home-Container {
  text-align: left;
}

.external-link {
  text-decoration: none;
}
.list-social-media {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 10px;

  .item-social-media {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
    .asset-rrecommendations {
      flex-direction: row;
    }

    img {
      width: 25px;
      height: 25px;
    }
  }
}
</style>
